(() => {
  'use strict';
  if (window.GrowplayKlaviyoReviews) return;
  window.GrowplayKlaviyoReviews = true;
  const host = location.hostname;
  const company = host.includes('growplayusa.com') || host.includes('growplay-monkey-bars-usa.myshopify.com')
    ? 'SknNPg'
    : host.includes('growplay-uk.myshopify.com') || host.includes('uk.growplaymonkeybars.com')
      ? 'YsDfh9'
      : host.includes('growplay-monkey-bars-nz.myshopify.com') || host.includes('nz.growplaymonkeybars.com')
        ? 'XdkXaP' : host.includes('growplaymonkeybars.com') || host.includes('growplay-monkey-bars.myshopify.com') ? 'VrhhP3' : '';
  if (!company) return;
  const selector = '#fulfilled-reviews-all, .growplay-reviews-carousel, .klaviyo-star-rating-widget, [id^="klaviyo-reviews"], [data-klaviyo-reviews], [data-klaviyo-product-reviews]';
  let timer;
  let renderedApi;
  let dialogObserver;
  let dialogTimer;
  const watchMediaDialog = control => {
    dialogObserver?.disconnect();
    clearTimeout(dialogTimer);
    let openedDialog;
    const stop = () => {
      dialogObserver.disconnect();
      clearTimeout(dialogTimer);
    };
    const check = () => {
      const dialog = document.querySelector('.kl_reviews__lightbox_background[role="dialog"]');
      if (dialog) {
        openedDialog = dialog;
        clearTimeout(dialogTimer);
        if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
          dialog.setAttribute('aria-label', 'Customer review photo or video');
        }
      } else if (openedDialog) {
        stop();
        if (control.isConnected && (document.activeElement === document.body || openedDialog.contains(document.activeElement))) {
          control.focus({preventScroll: true});
        }
      }
    };
    dialogObserver = new MutationObserver(check);
    dialogObserver.observe(document.body, {childList: true, subtree: true});
    // Observe only after media intent; stop if the vendor does not open a viewer.
    dialogTimer = setTimeout(stop, 30000);
    check();
  };
  const mediaIntent = event => {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    const control = event.target.closest?.('.kl_reviews__summary_image[role="button"]');
    if (control && !control.closest('[role="dialog"]')) watchMediaDialog(control);
  };
  document.addEventListener('click', mediaIntent, true);
  document.addEventListener('keydown', mediaIntent, true);
  const labelledRoots = new WeakSet();
  const labelMedia = root => {
    root.querySelectorAll('.kl_reviews__summary_image[role="button"]').forEach((control, index) => {
      if (control.getAttribute('aria-label') || control.getAttribute('aria-labelledby') || control.textContent.trim()) return;
      const type = control.classList.contains('kl_reviews__video_container') ? 'video' : 'photo';
      const title = control.querySelector('img')?.alt;
      control.setAttribute('aria-label', title || `View customer review ${type} ${index + 1}`);
    });
  };
  const observeMedia = () => {
    document.querySelectorAll('#klaviyo-product-reviews-wrapper, [data-gp-klaviyo-app-section]').forEach(root => {
      if (root.querySelector('template[data-gp-review-template]')) return;
      labelMedia(root);
      if (labelledRoots.has(root)) return;
      labelledRoots.add(root);
      new MutationObserver(() => labelMedia(root)).observe(root, {childList: true, subtree: true});
    });
  };
  const loader = () => document.querySelector('script[src*="/onsite/js/' + company + '/klaviyo.js"], script[data-gp-klaviyo-company="' + company + '"]');
  const ensureLoader = () => {
    if (loader()) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/' + company + '/klaviyo.js?company_id=' + company;
    script.dataset.gpKlaviyoCompany = company;
    document.head.append(script);
  };
  const render = () => {
    const api = window.klReviewsObject;
    if (!api || typeof api.renderWidgets !== 'function') return false;
    if (api !== renderedApi) {
      api.renderWidgets();
      renderedApi = api;
    }
    return true;
  };
  const init = () => {
    observeMedia();
    if (!document.querySelector(selector)) return;
    clearTimeout(timer);
    let attempts = 0;
    const check = () => {
      observeMedia();
      if (render()) return;
      if (++attempts < 50) timer = setTimeout(check, 500);
    };
    ensureLoader();
    check();
  };
  document.addEventListener('shopify:section:load', () => {
    renderedApi = undefined;
    init();
  });
  document.addEventListener('gp:klaviyo:refresh', event => {
    if (event.detail?.mounted) renderedApi = undefined;
    init();
  });
  window.__gpKlaviyoReviews = {companyId: company, refresh: init, renderNow: init};
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, {once: true});
})();
